import { useNavigate } from "react-router-dom";
import { CheckCircle, ArrowRight, BookOpen } from "lucide-react";

export default function CursusCard() {
  const navigate = useNavigate();
  return (
    <div data-testid="cursus-card" className="product-card cursus-featured flex flex-col h-full">
      <div className="product-card-header cursus-header">
        <div className="product-card-icon gold-icon"><BookOpen size={22} className="text-black" /></div>
        <div>
          <p className="text-xs font-bold uppercase tracking-widest text-[#C9A84C] mb-1">Online Cursus</p>
          <h3 className="text-2xl font-bold text-white">FitSmith PT Kickstart Program</h3>
          <p className="text-zinc-400 text-sm mt-1">Leer in 4 weken een professionele personal trainer worden</p>
        </div>
      </div>
      <div className="flex-1 flex flex-col p-6 gap-5">
        <div className="cursus-variant-label">
          <span className="cursus-variant-tag">Pro Versie</span>
          <span className="text-xs text-zinc-500 ml-2">Complete leerervaring</span>
        </div>
        <div className="goal-desc-box">
          <p className="text-sm text-zinc-300 leading-relaxed">
            Complete leerervaring met alle modules, lessen, werkboeken, toetsen en certificaat. De meest uitgebreide versie voor maximaal resultaat.
          </p>
        </div>
        <div className="space-y-2.5">
          {[
            "Perfect voor beginnende personal trainers",
            "Direct toepasbare kennis en schema's",
            "Bouw een sterke basis in 4 weken",
            "20+ lessen verdeeld over 4 modules",
            "Toetsen, eindtoets en certificaat",
          ].map(f => (
            <div key={f} className="flex items-center gap-2 text-sm text-zinc-300">
              <CheckCircle size={15} className="text-[#C9A84C] shrink-0" /> {f}
            </div>
          ))}
        </div>
        <div className="mt-auto pt-4 border-t border-white/10">
          <div className="flex items-end gap-2 mb-4">
            <span data-testid="cursus-price" className="text-3xl font-bold text-white">€399,95</span>
            <span className="text-zinc-400 text-sm mb-1">eenmalig</span>
          </div>
          <p className="text-xs text-zinc-600 mb-3 flex items-center gap-1">
            <span className="w-1 h-1 rounded-full bg-zinc-600 inline-block" />
            Dit is een digitaal product. Na aankoop is restitutie niet mogelijk.
          </p>
          <button data-testid="cursus-cta-btn" onClick={() => navigate("/bestellen?product=cursus")}
            className="btn-gold w-full py-3 font-bold text-sm uppercase tracking-wide">
            Cursus kopen <ArrowRight size={15} className="inline ml-1" />
          </button>
        </div>
      </div>
    </div>
  );
}
